import graphql from "babel-plugin-relay/macro";

export const AiSettingsQuery = graphql`
  query AiSettingsQuery {
    currentTenant {
      customerSettings {
        enableAi
      }
    }
  }
`;

export default AiSettingsQuery;
